import React from 'react';
import { cn } from '@/utils/cn';

interface SliderProps {
  value: number[];
  onValueChange: (value: number[]) => void;
  max: number;
  min: number;
  step: number;
  disabled?: boolean;
  className?: string;
}

export function Slider({ 
  value, 
  onValueChange, 
  max, 
  min, 
  step, 
  disabled = false, 
  className 
}: SliderProps) {
  const percentage = ((value[0] - min) / (max - min)) * 100;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(event.target.value);
    onValueChange([newValue]);
  };

  return (
    <div className={cn('relative flex w-full touch-none select-none items-center', className)}>
      <div className="relative flex-1">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value[0]}
          onChange={handleChange}
          disabled={disabled}
          className={cn(
            'w-full h-2 bg-secondary rounded-lg appearance-none cursor-pointer slider',
            'focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
            'disabled:opacity-50 disabled:cursor-not-allowed'
          )}
          style={{
            background: `linear-gradient(to right, hsl(var(--primary)) 0%, hsl(var(--primary)) ${percentage}%, hsl(var(--secondary)) ${percentage}%, hsl(var(--secondary)) 100%)`
          }}
        />
        <style dangerouslySetInnerHTML={{
          __html: `
            .slider::-webkit-slider-thumb {
              appearance: none;
              height: 20px;
              width: 20px;
              border-radius: 50%;
              background: hsl(var(--primary));
              cursor: pointer;
              border: 2px solid hsl(var(--background));
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }
            
            .slider::-moz-range-thumb {
              height: 20px;
              width: 20px;
              border-radius: 50%;
              background: hsl(var(--primary));
              cursor: pointer;
              border: 2px solid hsl(var(--background));
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }
          `
        }} />
      </div>
    </div>
  );
}